import type { Poll, Team } from '../lib/types';
import { PollCountdown } from './PollCountdown';

export function UmfrageStand({ poll, teams }: { poll: Poll | null; teams: Team[] }) {
  return <section className="panel">
    <h2>Challenge-Umfrage</h2>
    {!poll ? <p className="muted">Noch keine Challenge-Umfrage gestartet.</p> : <>
      <div className="poll-kopf"><strong>{poll.question}</strong>{poll.offen && <PollCountdown closesAt={poll.closesAt} />}</div>
      <p className="muted small">{poll.offen ? 'Aktueller Abstimmungsstand' : 'Abstimmung beendet – Ergebnis bleibt bis zur nächsten Umfrage sichtbar'}</p>
      <ul className="poll-antworten klein">{poll.antworten.map(a => <li key={a.id}>
        <div className="poll-balken" style={{ width: `${Math.round(a.anteil * 100)}%` }} />
        <span className="poll-nummer">{a.nummer}</span><span className="poll-label">{a.label}</span>
        <span className="poll-stimmen">{a.stimmen} · {Math.round(a.anteil * 100)} %</span>
      </li>)}</ul>
      {!poll.offen && (poll.mode === 'PER_CHANNEL' && poll.jeKanal ?
        <div><h3>Ergebnis je Kanal</h3>{poll.jeKanal.map(e => <p key={e.channelId}><strong>{teams.find(t => t.id === e.teamId)?.name ?? 'Kanal'}:</strong> {e.gewinner?.challenge ?? (e.gleichstand ? 'Gleichstand' : 'Keine Stimmen')}</p>)}</div> :
        <div className="challenge-ergebnis"><strong>{poll.ergebnis?.gewinner?.challenge ?? (poll.ergebnis?.gleichstand ? 'Gleichstand' : 'Keine Stimmen')}</strong>
        {poll.ergebnis?.gewinner && <span className="muted small"> · {poll.ergebnis.gewinner.label}</span>}</div>)}
    </>}
  </section>;
}
